"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var hideRemoveButton = function hideRemoveButton(count, index) {
  var customHideRemoveButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  if ((0, _lodash.isFunction)(customHideRemoveButton)) {
    return customHideRemoveButton();
  }
  return index === 0 && count <= 1;
};
var _default = exports["default"] = hideRemoveButton;